import { GET_TRANSACTIONAL_DATA_REPORT } from "../../../Types";

const ShopTransactionalDataReducer = (state = [], action) => {
  switch (action.type) {
    case GET_TRANSACTIONAL_DATA_REPORT:
     return {
    ...state,
    data: action.payload?.data || [],          // Make sure this exists
    totalRecords: action.payload?.totalRecords || 0, // And this exists
  };
    default:
      return state;
  }
};
export default ShopTransactionalDataReducer;
